export default "__VITE_ASSET__1N7_QEIj__"